module.exports = __webpack_public_path__ + "img/park-avenue-south_b2.32af68f8.jpg";